
import { useState } from "react";
import { Share2, Plus, Printer } from "lucide-react";
import { FundRawRecord } from "../funds-raw/types";
import { useParams } from "react-router-dom";
import { useToast } from "@/components/ui/use-toast";
import { useAddToPortfolio } from "@/hooks/portfolio/useAddToPortfolio";
import { ComboButton } from "@/components/ui/ComboButton";

interface FundHeaderProps {
  fundName: string;
  fundId?: string;
}

export function FundHeader({ fundName, fundId }: FundHeaderProps) {
  const [/* isAddDialogOpen */, /* setIsAddDialogOpen */] = useState(false);
  const { toast } = useToast();
  const params = useParams();
  const { openFundsRaw } = useAddToPortfolio();
  
  // If fundId wasn't provided as a prop, try to get it from URL params
  const effectiveFundId = fundId || params.fundId;
  
  // Create a minimal fund object for the AddToPortfolioDialog
  const fund: FundRawRecord | null = effectiveFundId ? {
    id: effectiveFundId,
    fund_name: fundName,
    fund_code: "",
    management_company_code: "",
    company_name: "",
    sa_asset_class: "",
    sa_sub_asset_class: ""
  } : null;
  
  const handleShare = () => {
    // For now, just copy the current URL to clipboard
    navigator.clipboard.writeText(window.location.href);
    toast({
      title: "Link copied to clipboard",
      description: "You can now share this fund with others."
    });
  };
  
  return (
    <div className="flex items-center justify-between w-full">
      <h1 className="text-2xl font-semibold">{fundName}</h1>
      <ComboButton
        label="Add to Portfolio"
        icon={<Plus className="h-4 w-4" />}
        size="sm"
        variant="outline"
        onPrimaryClick={() => {
          if (fund) {
            openFundsRaw({ fund, onSuccess: () => {
              toast({
                title: "Added to portfolio",
                description: `${fundName} has been added to your portfolio.`
              });
            }});
          }
        }}
        menuItems={[
          { label: "Share", onClick: handleShare, icon: <Share2 className="h-4 w-4" /> },
          { label: "Print", onClick: () => {
            toast({
              title: "Print functionality",
              description: "Print functionality is not yet implemented."
            });
          }, icon: <Printer className="h-4 w-4" /> },
        ]}
      />
      
      {/* Portfolio dialog is provided globally by FundsPortfolioDialogProvider */}
    </div>
  );
}
